// extracted by mini-css-extract-plugin
export default {"root":"_3USXW","align-items-center":"_3xiyX","alignItemsCenter":"_3xiyX","input":"_2-mNq"};